const editHistory = [
    {
    date: "2025-01-05T19:30:00",
    changes: [
      
      {
        type: "update",
        company: "Unicommerce",
        description: "Updated to completed with 5 students placed."
      }
      
    ]
  },
    {
    date: "2025-12-27T01:30:00",
    changes: [
      
      {
        type: "update",
        company: "TruEstate",
        description: "Updated to completed with 4 students placed."
      }
      
    ]
  },
  {
    date: "2025-12-24T01:30:00",
    changes: [
      {
        type: "add",
        company: "Saturn IQ, Thingliasta automation, Saint Fox, Layer 3 Inc., Trisx Technologies Pvt. Ltd. ",
        description: "Added in off campus"
      },
      {
        type: "add",
        company: "BOT Consulting",
        description: "Added in on campus"
      },
      {
        type: "update",
        company: "TruEstate, Evigway Technologies, OTSI, Signzy, Serent Corporation, Samsung etc.",
        description: "Updated and corrected data"
      }
      
    ]
  },
    {
    date: "2025-12-20T13:30:00",
    changes: [
      
      {
        type: "add",
        company: "Coinswitch",
        description: "Added new entry"
      }
      
    ]
  },
    {
    date: "2025-12-20T00:30:00",
    changes: [
      {
        type: "update",
        company: "Eucloid",
        description: "Updated drive to Completed with 6 students placed."
      },
      {
        type: "add",
        company: "Hero Vired",
        description: "Added new entry"
      },
      {
        type: "add",
        company: "TruEsate",
        description: "Added new entry with pending placements"
      },
      {
        type: "add",
        company: "Evigway Technologies",
        description: "Added new entry with pending placements"
      },
      {
        type: "add",
        company: "OTSI",
        description: "Added new entry with pending placements"
      },
      {
        type: "add",
        company: "Evam Labs",
        description: "Added new entry with pending placements"
      },
      {
        type: "add",
        company: "Signzy",
        description: "Added new entry with pending placements"
      }
      
    ]
  },
   {
    date: "2025-12-17T17:30:00",
    changes: [
      {
        type: "add",
        company: "ProcMart",
        description: "Added new entry"
      },
      
    ]
  },
  {
    date: "2025-12-16T14:30:00",
    changes: [
      {
        type: "update",
        company: "Deloitte",
        description: "Updated placed students from 18 to 16"
      },
      
    ]
  }
  
  
];

export default editHistory;
